import { SymbolIndexTaskPriorityHeap } from './task-priority-heap.js';
import { symbolIndexTaskKey, type PendingSymbolIndexTask } from './task-queue-types.js';

export const pendingSymbolIndexTasks = new Map<string, PendingSymbolIndexTask>();
export const symbolIndexTaskHeap = new SymbolIndexTaskPriorityHeap();
export const latestActiveSequenceByParent = new Map<string, number>();
export let symbolIndexWorkerRunning = false;

export function setSymbolIndexWorkerRunning(running: boolean): void {
  symbolIndexWorkerRunning = running;
}

export function taskMatchesCurrentPending(task: PendingSymbolIndexTask): boolean {
  const current = pendingSymbolIndexTasks.get(symbolIndexTaskKey(task.parentPath, task.filePath));
  return current === task;
}

export function pickNextSymbolIndexTask(): PendingSymbolIndexTask | undefined {
  while (symbolIndexTaskHeap.size > 0) {
    const task = symbolIndexTaskHeap.pop();
    if (task == null || !taskMatchesCurrentPending(task)) continue;
    return task;
  }
  return undefined;
}

export function addPendingSymbolIndexTask(task: PendingSymbolIndexTask): boolean {
  const key = symbolIndexTaskKey(task.parentPath, task.filePath);
  const existing = pendingSymbolIndexTasks.get(key);
  if (existing != null && existing.priority >= task.priority) return false;
  pendingSymbolIndexTasks.set(key, task);
  symbolIndexTaskHeap.push(task);
  return true;
}

export function clearSymbolIndexHeapIfEmpty(): void {
  if (pendingSymbolIndexTasks.size === 0) symbolIndexTaskHeap.clear();
}

/** @internal Test teardown for worker queue state. */
export function resetSymbolIndexTaskQueueForTests(): void {
  pendingSymbolIndexTasks.clear();
  symbolIndexTaskHeap.clear();
  latestActiveSequenceByParent.clear();
  symbolIndexWorkerRunning = false;
}
